import http from './wx-http-axios'

const isProd = process.env.NODE_ENV === 'production'

export const HOST = process.env.VUE_APP_HOST
export const FUZZ_HOST = process.env.VUE_APP_FUZZ_HOST
export const GFT_HOST = process.env.VUE_APP_GFT_HOST + 'cd/'
export const NORMAL_HOST = process.env.VUE_APP_NORMAL_HOST
const common_headers = {
    'content-type': 'application/json'
}
const headers = {
    ...common_headers,
    'WX-KEY-VERSION': 1
}
const NO_FUZZ_OPTIONS = {
    headers: common_headers,
    data: {},
    fuzz: false
}

export const normal_axios =  http.create({
    baseURL: NORMAL_HOST,
    ...NO_FUZZ_OPTIONS
})

const getService = (fuzz = false, path = '') => {
    return http.create({
        baseURL: `${fuzz ? FUZZ_HOST : HOST}${path}`,
        headers,
        data: {},
        fuzz: true
    })
}
export const gft_axios = http.create({
    baseURL: GFT_HOST,
    headers,
    data: {},
    fuzz: true
})

export default getService(isProd)
